import axios from 'axios'
import { timingIntent, validTimingDate } from './orderTiming2'

export const EVENT_VERSION = 'order-event-feasibility-v1'
export function earliestEventDate (now = new Date(), holidays = []) {
  const cursor = new Date(now)
  if (parseInt(now.toLocaleString('en-US', { timeZone: 'America/Chicago', hour12: false, hour: 'numeric' }), 10) >= 14) cursor.setDate(cursor.getDate() + 1)
  cursor.setHours(0, 0, 0, 0)
  let count = 0
  while (count < 4) {
    if (![0, 6].includes(cursor.getDay()) && !holidays.includes(localDate(cursor))) count++
    if (count < 4) cursor.setDate(cursor.getDate() + 1)
  }
  return localDate(cursor)
}
export function localDate (date) {
  return [date.getFullYear(), String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0')].join('-')
}
const primary = value => Number(value) || 0
const sizes = rows => (rows || []).filter(s => Number(s.quantity) > 0).map(s => ({ size_id: primary(s.size_id), quantity: Number(s.quantity) }))
function colors (rows) {
  return (rows || []).map(c => ({ color_id: primary(c.color_id), sizes: sizes(c.sizes), inner_colors: (c.inner_colors || []).map(i => ({ color_id: primary(i.color_id), sizes: sizes(i.sizes) })).filter(i => i.sizes.length) })).filter(c => c.sizes.length || c.inner_colors.length)
}
export function schedulingPayload (form, groups) {
  const t = timingIntent(form && form.scheduling_intent)
  return {
    workspace_id: String((form && (form.timing_workspace_id || form.saved_id)) || 'current-workspace'),
    browser_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Chicago',
    event_date: t.event_order ? t.in_hands_date : '',
    future_ship_date_boolean: t.future_ship_date_boolean,
    future_ship_date: t.future_ship_date_boolean ? t.future_ship_date : null,
    groups: (groups || []).map(g => ({ group_id: String(g.group_id), order_items: (g.order_items || []).map(item => ({
      section_id: String(item.section_id || ''), line_id: String(item.line_id || item.style_line_id || ''),
      program_info: { program_id: primary(item.program_info && item.program_info.program_id) },
      style_info: { style_id: primary(item.style_info && item.style_info.style_id), product_class: String((item.style_info && item.style_info.product_class) || '') },
      blank_order: [true, 1, '1'].includes(item.blank_order) ? 1 : 0,
      order_item_colors: colors(item.order_item_colors),
      order_item_locations: (item.order_item_locations || []).map(l => ({
        bundle_placement_id: String(l.bundle_placement_id || l.id || ''),
        ptl_identity: [primary(item.program_info && item.program_info.program_id), primary(l.technique && l.technique.technique_id), primary(l.location && l.location.location_id)].join(':'),
        technique: { technique_id: primary(l.technique && l.technique.technique_id) }, location: { location_id: primary(l.location && l.location.location_id) }
      }))
    })).filter(item => item.order_item_colors.length) })).filter(g => g.order_items.length)
  }
}

export default {
  data () { return { eventResult2: null, eventResultKey2: '', eventLoading2: false, eventAutoPending2: false, eventError2: '', eventModal2: false, eventSeenKeys2: [], eventGeneration2: 0, eventHolidays2: null, eventCalendarError2: false, eventClock2: Date.now() } },
  computed: {
    eventActive2 () { return timingIntent(this.schedulingForm2() && this.schedulingForm2().scheduling_intent).event_order },
    eventValidationVisible2 () { const value = timingIntent(this.schedulingForm2() && this.schedulingForm2().scheduling_intent); return value.event_order && validTimingDate(value.in_hands_date) },
    eventEarliest2 () { return this.eventHolidays2 ? earliestEventDate(new Date(this.eventClock2), this.eventHolidays2) : '' },
    eventPayload2 () { return this.eventActive2 ? schedulingPayload(this.schedulingForm2(), this.schedulingGroups2()) : null },
    eventKey2 () { return this.eventPayload2 ? JSON.stringify([this.eventPayload2, this.eventEarliest2, localDate(new Date(this.eventClock2)), new Date(this.eventClock2).toLocaleDateString('en-CA', { timeZone: 'America/Chicago' }), parseInt(new Date(this.eventClock2).toLocaleString('en-US', { timeZone: 'America/Chicago', hour12: false, hour: 'numeric' }), 10) >= 14]) : '' },
    eventCurrent2 () { return !this.eventActive2 || (!!this.eventResult2 && this.eventResultKey2 === this.eventKey2 && !this.eventLoading2) },
    eventAuthorized2 () { return !this.eventActive2 || (this.eventCurrent2 && !this.eventError2 && !this.eventCalendarError2 && this.eventResult2.status === 'feasible' && !!this.eventEarliest2 && this.eventPayload2.event_date >= this.eventEarliest2) },
    eventMessage2 () {
      if (!this.eventActive2) return ''
      if (this.eventCalendarError2) return 'Event calendar could not be loaded. Retry the schedule check.'
      if (this.eventLoading2) return 'Checking the ordinary schedule…'
      if (this.eventError2) return this.eventError2
      if (!this.eventCurrent2) return 'The current production configuration is being checked.'
      return this.eventResult2.message
    }
  },
  watch: {
    eventKey2 () { this.eventGeneration2++; this.eventModal2 = false; this.eventLoading2 = false; this.eventError2 = ''; this.queueEventSchedule2() },
    eventActive2: { immediate: true, handler (active) { if (active) this.loadEventCalendar2().then(() => this.queueEventSchedule2()) } }
  },
  mounted () {
    this._eventClockHandler2 = () => { this.eventClock2 = Date.now() }
    window.addEventListener('focus', this._eventClockHandler2)
    this._eventClockTimer2 = setInterval(this._eventClockHandler2, 60000)
  },
  beforeDestroy () { this.eventGeneration2++; clearTimeout(this._eventAutoTimer2); clearInterval(this._eventClockTimer2); window.removeEventListener('focus', this._eventClockHandler2) },
  methods: {
    queueEventSchedule2 () {
      clearTimeout(this._eventAutoTimer2)
      if (!this.eventValidationVisible2 || !this.eventEarliest2 || !this.eventPayload2 || !this.eventPayload2.groups.length) { this.eventAutoPending2 = false; return }
      this.eventAutoPending2 = true
      const key = this.eventKey2
      this._eventAutoTimer2 = setTimeout(() => {
        if (key !== this.eventKey2) return
        this.refreshEventSchedule2(false).finally(() => { if (key === this.eventKey2) this.eventAutoPending2 = false })
      }, 400)
    },
    loadEventCalendar2 () {
      if (this.eventHolidays2) return Promise.resolve(true)
      if (this._eventCalendarPromise2) return this._eventCalendarPromise2
      this.eventCalendarError2 = false
      this._eventCalendarPromise2 = axios.get(this.$apiAdress + '/api/getHolidays', { params: { token: localStorage.getItem('api_token') } }).then(response => {
        if (!Array.isArray(response.data)) throw new Error('Missing calendar')
        this.eventHolidays2 = response.data.map(row => String(row.date || '').slice(0, 10)).filter(validTimingDate)
        return true
      }).catch(() => { this.eventCalendarError2 = true; return false }).finally(() => { this._eventCalendarPromise2 = null })
      return this._eventCalendarPromise2
    },
    schedulingRequirements2 () {
      if (!this.eventActive2 || this.eventAuthorized2) return []
      return [{ requirementId: 'event-schedule', code: 'event_schedule', message: this.eventMessage2, step: 3, action: 'check_event_schedule', actionLabel: 'Check Event Schedule', target: 'event-schedule2', blocking: true }]
    },
    async refreshEventSchedule2 (showModal = true) {
      if (!this.eventActive2) return true
      this.eventClock2 = Date.now()
      if (!(await this.loadEventCalendar2())) return false
      await this.$nextTick()
      const payload = this.eventPayload2
      if (!validTimingDate(payload.event_date) || !payload.groups.length) { this.eventError2 = 'Select a valid Event Date and complete the Style configurations and quantities, then check the schedule.'; return false }
      const key = this.eventKey2
      if (this._eventPending2 && this._eventPending2.key === key && this._eventPending2.generation === this.eventGeneration2) return this._eventPending2.promise
      const generation = ++this.eventGeneration2
      clearTimeout(this._eventAutoTimer2); this.eventAutoPending2 = false; this.eventLoading2 = true; this.eventError2 = ''
      const promise = axios.post(this.$apiAdress + '/api/orders/v2/event-feasibility', payload, { params: { token: localStorage.getItem('api_token') } }).then(response => {
        if (key !== this.eventKey2 || generation !== this.eventGeneration2) return false
        const result = response.data
        if (!result || result.version !== EVENT_VERSION || !/^[a-f0-9]{64}$/.test(result.fingerprint || '') || !['feasible', 'infeasible', 'invalid_date', 'invalid_window', 'unconfirmed'].includes(result.status) || result.event_date !== payload.event_date) throw new Error('Missing schedule confirmation')
        this.eventResult2 = result; this.eventResultKey2 = key
        if (showModal && result.status === 'infeasible' && !this.eventSeenKeys2.includes(key)) { this.eventSeenKeys2.push(key); this.eventModal2 = true }
        return result.status === 'feasible'
      }).catch(() => {
        if (key === this.eventKey2 && generation === this.eventGeneration2) this.eventError2 = 'The ordinary schedule could not be confirmed. Retry; your order has been preserved.'
        return false
      }).finally(() => { if (generation === this.eventGeneration2) this.eventLoading2 = false; if (this._eventPending2 && this._eventPending2.promise === promise) this._eventPending2 = null })
      this._eventPending2 = { key, generation, promise }
      return promise
    },
    moveEventDate2 () {
      if (!this.eventCurrent2 || !this.eventResult2.controlling_ship_date) return
      const date = [this.eventResult2.controlling_ship_date, this.eventResult2.earliest_event_date].sort().pop()
      const next = { ...this.schedulingForm2().scheduling_intent, in_hands_date: date }
      this.eventModal2 = false
      this.applyEventTiming2(next)
      this.$nextTick(() => this.refreshEventSchedule2(false))
    }
  }
}
